export default __webpack_public_path__ + "static/media/drag.71fe0c1f.svg";